import { motion } from "framer-motion";

const easing = [0.22, 1, 0.36, 1];

export const RevealLine = ({ children, delay = 0, className = "" }) => (
  <span className="reveal-mask align-baseline" style={{ display: "inline-block" }}>
    <motion.span
      initial={{ y: "110%" }}
      whileInView={{ y: "0%" }}
      viewport={{ once: true, amount: 0.01 }}
      transition={{ duration: 0.9, ease: easing, delay }}
      className={className}
      style={{ display: "inline-block" }}
    >
      {children}
    </motion.span>
  </span>
);

export const FadeUp = ({ children, delay = 0, className = "", y = 18 }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.01 }}
    transition={{ duration: 0.7, ease: easing, delay }}
    className={className}
  >
    {children}
  </motion.div>
);

export const easings = easing;
